import i18n from '@Lang/i18n';
import sha from 'sha.js';
import Big from "big.js";
import Clipboard from "clipboard";
import {v4 as uuid} from 'uuid';

export function getParameterByName(name:string) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
/**
 * 확장자 가져오기
 */
export function getExtension(fileName: string) {
	let fileLength = fileName.length;
	let lastDot = fileName.lastIndexOf('.');
	let fileExtension = fileName.substring(lastDot + 1, fileLength);
	return fileExtension;
}

/**
 * 숫자 -> 알파벳
 */
export function numToSSColumn(num: number) {
	let s = '', t;

	while (num > 0) {
		t = (num - 1) % 26;
		s = String.fromCharCode(65 + t) + s;
		num = (num - t) / 26 | 0;
	}
	return s || undefined;
}

/**
 * 입력값이 null 인지 체크
 * @returns	boolean		=> true/false
 */
export function isNull(_data: any) {
	if (_data === "null" || _data === null || _data === undefined) {
		return true;
	}

	if (_data.length === 0) {
		return true;
	}
	return false;
}

/**
 * null값인 경우 지정한 값으로 치환
 */
export function getNvl(_data1: string, _data2: string) {
	return (isNull(_data1)) ? _data2 : _data1;
}

/**
 * 데이터를 특정문자로 치환
 */
export function replace(_data: string, _old: any, _new: any) {
	return _data.split(_old).join(_new);
}

/**
 * 데이터를 특정문자로 치환
 */
 export function copyJson(_data: object) {
	return JSON.parse(JSON.stringify(_data));
}

/**
 * rem to px
 */
 export function remToPixels(rem: any) {
	return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

/**
 * sha256변환
 */
export function sha256(val: string) {
	const sha256 = sha('sha256');
	sha256.init();
	return sha256.update(val, 'utf8').digest('base64');
}

/**
 * 숫자에 콤마 찍기
 * @param	 val 		=> 숫자 , 또는 숫자형태의 문자열
 * @returns	 Number		=> format을 "###,###"로 처리
 */
 export function setNumberComma(val:any) {
	if(val == 0) return val; 
	const reg = /(^[+-]?\d+)(\d{3})/;
	let n = (val + '');	 
	while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');	 
	return n;

}

/**
 * 패스워드 체크(영문+숫자+특수기호 포함 9자리)
 */
export function passwordCheck(val: string) {
	var regExp = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{9,}$/; 
	
	return regExp.test(val);
}

/**
 * GUID 채번
 */
export function createGuid() {
	return replace(uuid(),'-','');
};


/**
 * 데이터의 왼쪽을 시작으로 지정한 자릿수만큼 특정문자를 삽입하여 반환
 */
export function lPad(_data: string, _length: number, _char: string) {
	if (isNull(_data)) {
		_data = "";
	}
	let strChar = "";
	let nIteration = _length - _data.length;
	for (let i = 0; i < nIteration; i++) {
		strChar = _char + strChar;
	}
	return (strChar + _data);
}


/**
 * 데이터의 오른쪽을 시작으로 지정한 자릿수만큼 특정문자를 삽입하여 반환
 */
export function rPad(_data: string, _length: number, _char: string) {
	if (isNull(_data)) {
		_data = "";
	}
	let nIteration = _length - _data.length;
	for (let i = 0; i < nIteration; i++) {
		_data = _data + _char;
	}
	return _data;
}

/**
 * 데이터의 오른쪽부터 지정한 길이만큼을 반환
 */
export function right(_data: string, _length: number) {
	let strIndex = _data.length - _length
	return _data.substring(strIndex);
}

/**
 * 주민등록번호 유효성 체크
 */
export function isJuminNo(_juminNo: string) {
	let juminNo_regex = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-?[1-4][0-9]{6}$/;			// 주민등록번호 패턴체크
	if (!juminNo_regex.test(_juminNo)) {
		return false;
	} else {
		let val, val1, val2;

		if (_juminNo.length === 14) {																				// 주민등록번호 유효성체크
			val = _juminNo.split('-');
			val1 = val[0];
			val2 = val[1];
		}

		if (_juminNo.length === 13) {
			val1 = _juminNo.substr(0, 6);
			val2 = _juminNo.substr(6, 7);
		}

		if (val1 && val2) {
			let tmp = val2.substr(0, 1);
			let ForeignerFg;
			if (tmp <= "4") {
				ForeignerFg = true;		//내국인
			} else {
				ForeignerFg = false;	//외국인
			}
			let t1 = parseInt(val1.substr(0, 1));
			let t2 = parseInt(val1.substr(1, 1));
			let t3 = parseInt(val1.substr(2, 1));
			let t4 = parseInt(val1.substr(3, 1));
			let t5 = parseInt(val1.substr(4, 1));
			let t6 = parseInt(val1.substr(5, 1));
			let t11 = parseInt(val2.substr(0, 1));
			let t12 = parseInt(val2.substr(1, 1));
			let t13 = parseInt(val2.substr(2, 1));
			let t14 = parseInt(val2.substr(3, 1));
			let t15 = parseInt(val2.substr(4, 1));
			let t16 = parseInt(val2.substr(5, 1));
			let t17 = parseInt(val2.substr(6, 1));
			let tot = t1 * 2 + t2 * 3 + t3 * 4 + t4 * 5 + t5 * 6 + t6 * 7;
			tot += t11 * 8 + t12 * 9 + t13 * 2 + t14 * 3 + t15 * 4 + t16 * 5;
			let result = tot % 11;
			if (ForeignerFg) {
				result = (11 - result) % 10;	//내국인
			} else {
				result = (13 - result) % 10;	//내국인
			}
			if (result === t17) {
				return true;
			}
		}

		return false;
	}
}

/**
 * 이메일 유효성 체크
 */
export function isEmail(_email: string) {
	let email_regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
	if (!email_regex.test(_email)) {
		return false;
	} else {
		return true;
	}
}
/**
 *  값이 비어있는지 체크
 */
export function  isEmpty(value: any) {
	if (typeof (value) == 'function' || typeof (value) == 'number' || typeof (value) == 'boolean' || Object.prototype.toString.call(value) === '[object Date]'){
		return false;
	}

	return (value == null || value == undefined || value == "" || value.length == 0 || Object.getOwnPropertyNames(value).length == 0);
}

/**
 *  언어에 따라 메세지처리
 */
export function langChangeMsg(koMsg:any,enMsg:any) {

	return i18n.language === 'ko' ? koMsg : enMsg;
}

export function converterUnitVal(unitCd:string,converterUnitCd:string,val:any){

	if(!val){
		return val;
	}

	val = new Big(val);

	if(unitCd === '101'){
		if(converterUnitCd === '102'){
			val = val.div(1000);
		}else if(converterUnitCd === '103'){
			val = val.div(10000);
		}else if(converterUnitCd === '104'){
			val = val.div(1000000);
		}else if(converterUnitCd === '105'){
			val = val.div(100000000);
		}else if(converterUnitCd === '106'){
			val = val.div(1000000000);
		}else if(converterUnitCd === '107'){
			val = val.div(100000000000);
		}else if(converterUnitCd === '108'){
			val = val.div(1000000000000);
		}
	}else if(unitCd === '102'){
		if(converterUnitCd === '101'){
			val = val.times(1000);
		}else if(converterUnitCd === '103'){
			val = val.div(10);
		}else if(converterUnitCd === '104'){
			val = val.div(1000);
		}else if(converterUnitCd === '105'){
			val = val.div(100000);
		}else if(converterUnitCd === '106'){
			val = val.div(1000000);
		}else if(converterUnitCd === '107'){
			val = val.div(100000000);
		}else if(converterUnitCd === '108'){
			val = val.div(1000000000);
		}
	}else if(unitCd === '103'){
		if(converterUnitCd === '101'){
			val = val.times(10000);
		}else if(converterUnitCd === '102'){
			val = val.times(10);
		}else if(converterUnitCd === '104'){
			val = val.div(100);
		}else if(converterUnitCd === '105'){
			val = val.div(10000);
		}else if(converterUnitCd === '106'){
			val = val.div(100000);
		}else if(converterUnitCd === '107'){
			val = val.div(10000000);
		}else if(converterUnitCd === '108'){
			val = val.div(100000000);
		}
	}else if(unitCd === '104'){
		if(converterUnitCd === '101'){
			val = val.times(1000000);
		}else if(converterUnitCd === '102'){
			val = val.times(1000);
		}else if(converterUnitCd === '103'){
			val = val.times(100);
		}else if(converterUnitCd === '105'){
			val = val.div(100);
		}else if(converterUnitCd === '106'){
			val = val.div(1000);
		}else if(converterUnitCd === '107'){
			val = val.div(100000);
		}else if(converterUnitCd === '108'){
			val = val.div(1000000);
		}
	}else if(unitCd === '105'){
		if(converterUnitCd === '101'){
			val = val.times(100000000);
		}else if(converterUnitCd === '102'){
			val = val.times(100000);
		}else if(converterUnitCd === '103'){
			val = val.times(10000);
		}else if(converterUnitCd === '104'){
			val = val.times(100);
		}else if(converterUnitCd === '106'){
			val = val.div(10);
		}else if(converterUnitCd === '107'){
			val = val.div(1000);
		}else if(converterUnitCd === '108'){
			val = val.div(10000);
		}
	}else if(unitCd === '106'){
		if(converterUnitCd === '101'){
			val = val.times(1000000000);
		}else if(converterUnitCd === '102'){
			val = val.times(1000000);
		}else if(converterUnitCd === '103'){
			val = val.times(100000);
		}else if(converterUnitCd === '104'){
			val = val.times(1000);
		}else if(converterUnitCd === '105'){
			val = val.times(10);
		}else if(converterUnitCd === '107'){
			val = val.div(100);
		}else if(converterUnitCd === '108'){
			val = val.div(1000);
		}
	}else if(unitCd === '107'){
		if(converterUnitCd === '101'){
			val = val.times(100000000000);
		}else if(converterUnitCd === '102'){
			val = val.times(100000000);
		}else if(converterUnitCd === '103'){
			val = val.times(10000000);
		}else if(converterUnitCd === '104'){
			val = val.times(100000);
		}else if(converterUnitCd === '105'){
			val = val.times(1000);
		}else if(converterUnitCd === '106'){
			val = val.times(100);
		}else if(converterUnitCd === '108'){
			val = val.div(10);
		}
	}else if(unitCd === '108'){
		if(converterUnitCd === '101'){
			val = val.times(1000000000000);
		}else if(converterUnitCd === '102'){
			val = val.times(1000000000);
		}else if(converterUnitCd === '103'){
			val = val.times(100000000);
		}else if(converterUnitCd === '104'){
			val = val.times(1000000);
		}else if(converterUnitCd === '105'){
			val = val.times(10000);
		}else if(converterUnitCd === '106'){
			val = val.times(1000);
		}else if(converterUnitCd === '107'){
			val = val.times(10);
		}
	}else if(unitCd === '111'){
		if(converterUnitCd === '112'){
			val = val.div(1000);
		}else if(converterUnitCd === '113'){
			val = val.div(10000);
		}else if(converterUnitCd === '114'){
			val = val.div(1000000);
		}else if(converterUnitCd === '115'){
			val = val.div(100000000);
		}else if(converterUnitCd === '116'){
			val = val.div(1000000000);
		}
	}else if(unitCd === '112'){
		if(converterUnitCd === '111'){
			val = val.times(1000);
		}else if(converterUnitCd === '113'){
			val = val.div(10);
		}else if(converterUnitCd === '114'){
			val = val.div(1000);
		}else if(converterUnitCd === '115'){
			val = val.div(100000);
		}else if(converterUnitCd === '116'){
			val = val.div(1000000);
		}
	}else if(unitCd === '113'){
		if(converterUnitCd === '111'){
			val = val.times(10000);
		}else if(converterUnitCd === '112'){
			val = val.times(10);
		}else if(converterUnitCd === '114'){
			val = val.div(100);
		}else if(converterUnitCd === '115'){
			val = val.div(10000);
		}else if(converterUnitCd === '116'){
			val = val.div(100000);
		}
	}else if(unitCd === '114'){
		if(converterUnitCd === '111'){
			val = val.times(1000000);
		}else if(converterUnitCd === '112'){
			val = val.times(1000);
		}else if(converterUnitCd === '113'){
			val = val.times(100);
		}else if(converterUnitCd === '115'){
			val = val.div(100);
		}else if(converterUnitCd === '116'){
			val = val.div(1000);
		}
	}else if(unitCd === '115'){
		if(converterUnitCd === '111'){
			val = val.times(100000000);
		}else if(converterUnitCd === '112'){
			val = val.times(100000);
		}else if(converterUnitCd === '113'){
			val = val.times(10000);
		}else if(converterUnitCd === '114'){
			val = val.times(100);
		}else if(converterUnitCd === '116'){
			val = val.div(10);
		}
	}else if(unitCd === '116'){
		if(converterUnitCd === '111'){
			val = val.times(1000000000);
		}else if(converterUnitCd === '112'){
			val = val.times(1000000);
		}else if(converterUnitCd === '113'){
			val = val.times(100000);
		}else if(converterUnitCd === '114'){
			val = val.times(1000);
		}else if(converterUnitCd === '115'){
			val = val.times(10);
		}
	}
	return parseFloat(val.toFixed());
}
/**
 *  언어 Retrun
 */
export function getLanguage() {
	return i18n.language;
}

/**
 *  언어 EscapeHtml
 */
export function getEscapeHtml(val:any) {
	let html = "";
	const parser = new DOMParser().parseFromString(val,'text/html');

	if(parser.documentElement.textContent){
		html = parser.documentElement.textContent;
	}
	
	return html;
}
/**
 *  클립보드 복사
 */
export function copyClipboard(val:any,msg:string) {

	const copyTextAreaEle = document.createElement('textarea');
	const clipboardEle = document.createElement('button');

	document.body.appendChild(copyTextAreaEle);
	document.body.appendChild(clipboardEle);

	copyTextAreaEle.id = 'copytextarea';
	copyTextAreaEle.value = val;
	clipboardEle.setAttribute('data-clipboard-action','copy');
	clipboardEle.setAttribute('data-clipboard-target','#copytextarea');
	
	const clipboard = new Clipboard(clipboardEle);
	clipboard.on('success',function(e){
		if(msg){
			alert(msg);
		}
		document.body.removeChild(copyTextAreaEle);
		document.body.removeChild(clipboardEle);
	})

	clipboardEle.click();
}

export function stringByteLength(str:any){

	const val = new String(str);
	let charCnt = 0 ;

	for(let i=0;i<val.length;i++){
		if(escape(val.charAt(i)).length > 4){
			charCnt += 2;
		}else{
			charCnt++;
		}
	}

	return charCnt;
}

export function getTextWidth(str:string) {
	let width = 0;

	const span:any = document.createElement('span');
	document.body.appendChild(span);

	span['textContent'] = str;
	span['style']['fontSize'] = '14px';
	span['style']['padding'] = '4px';
	span['style']['whiteSpace'] = 'pre-wrap';
	width = span['offsetWidth'];

	document.body.removeChild(span);
	
	return Math.ceil((width*1.3));
}
